/**
 * Volume Discount — Nudge Bar + Active Tier Highlight
 * File: assets/volume-discount.js
 * Reads cart item count and updates the nudge bar + highlights active tier row.
 * No dependencies. Works with Shopify Ajax Cart API.
 */

(function () {
  'use strict';

  var TIERS = [
    { qty: 1, pct: 30, next: 40, nextQty: 2 },
    { qty: 2, pct: 40, next: 50, nextQty: 3 },
    { qty: 3, pct: 50, next: null, nextQty: null }
  ];

  function getActiveTier(qty) {
    if (qty <= 0) return null;
    if (qty === 1) return TIERS[0];
    if (qty === 2) return TIERS[1];
    return TIERS[2];
  }

  function updateUI(cartQty) {
    var table = document.getElementById('volume-discount-table');
    if (!table) return;

    // --- Highlight active tier row ---
    var tierRows = table.querySelectorAll('.vdt-tier');
    tierRows.forEach(function (row) {
      row.classList.remove('vdt-tier--active');
    });

    var activeTier = getActiveTier(cartQty);
    if (activeTier) {
      var activeRow = table.querySelector('.vdt-tier[data-qty="' + activeTier.qty + '"]');
      if (activeRow) activeRow.classList.add('vdt-tier--active');
    }

    // --- Nudge bar ---
    var nudge     = document.getElementById('vdt-nudge');
    var nudgeText = document.getElementById('vdt-nudge-text');
    if (!nudge || !nudgeText) return;

    if (cartQty <= 0) {
      // Nothing in cart yet — show entry nudge
      nudge.style.display = 'block';
      nudgeText.innerHTML = 'Add <strong>1 item</strong> to unlock <strong>30% off</strong>';
      return;
    }

    if (cartQty === 1) {
      nudge.style.display = 'block';
      nudgeText.innerHTML = 'Add <strong>1 more</strong> to unlock <strong>40% off</strong>';
      return;
    }

    if (cartQty === 2) {
      nudge.style.display = 'block';
      nudgeText.innerHTML = 'Add <strong>1 more</strong> to unlock <strong>50% off</strong>';
      return;
    }

    // 3+ — max tier reached
    nudge.style.display = 'block';
    nudgeText.innerHTML = "You've unlocked the <strong>best deal — 50% off!</strong> 🎉";
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateUI(cart.item_count);
      })
      .catch(function () {
        // Silently fail — UI stays static
      });
  }

  // --- Init on DOM ready ---
  function init() {
    fetchCartAndUpdate();

    // Listen for cart updates dispatched by Pipeline / Shopify themes
    // Pipeline uses 'cart:updated', 'cart:refresh' and also dispatches on window
    var cartEvents = ['cart:updated', 'cart:refresh', 'cart:item-added'];
    cartEvents.forEach(function (evt) {
      document.addEventListener(evt, fetchCartAndUpdate);
      window.addEventListener(evt, fetchCartAndUpdate);
    });

    // Also hook into native fetch/XHR to catch Ajax add-to-cart
    // Pipeline 7 uses fetch for cart operations
    var _fetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url  = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      return _fetch.apply(this, args).then(function (response) {
        if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
          // Small delay to let Shopify process
          setTimeout(fetchCartAndUpdate, 300);
        }
        return response;
      });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();